import urlUtils from 'utils/urlUtils'

function convertImage(el, binding) {
  const value = binding.value || {}

  if (value.src) {
    el.src = urlUtils.optimizedImageUrl(value.src, {
      height: value.height,
    })
  }
}

export default {
  bind(el, binding, vnode) {
    convertImage(el, binding, vnode)

    el.addEventListener('load', () => {
      vnode.context.$emit('load')
    })
  },
  update(el, binding, vnode) {
    convertImage(el, binding, vnode)
  },
}



// WEBPACK FOOTER //
// ./src/directives/imgSrc.js